import React, { Component } from 'react';
import { Drawer, Button, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import colors from 'utils/colors';
import { DialogWrapper } from 'components/DialogWrapper';
import PrescreenAnswers from 'containers/Manage-Questionnaire/prescreen/PrescreenAnswers';
import {
  DrawerHeader,
  FlexRow,
  BlueTextPointer,
  PlainButton,
  CategoryLabel,
  BorderWrapper,
} from 'components/styled-components';
import map from 'lodash/map';
import filter from 'lodash/filter';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import Select from 'react-select';
import FormTextAreaGroup from 'components/forms/components/form-text-area-group';
import ErrorWrapper from 'components/forms/components/error-wrapper';
import { createPrescreenQuestion } from 'api/prescreen';
import { AppToaster } from 'components/AppToaster';
import {
  HeaderControls,
  ScrollWrapper,
} from 'containers/Manage-Questionnaire/styled-components';

const mapAnswerLimit = val => {
  if (typeof val === 'number') {
    return val === 0
      ? { label: 'No Limit', value: 0 }
      : { label: val, value: val };
  } else {
    return val;
  }
};

const initialState = {
  editMade: false,
  removeQuestion: false,
  closeWithoutSaving: false,
  questionError: false,
  question: '',
  answerLimit: 0,
  addingAnswer: false,
  answers: [],
  editingAnswer: false,
  answerToEdit: {},
};

class PrescreenAddQuestionDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = cloneDeep(initialState);
  }

  handleCloseDrawer = () => {
    if (this.state.editMade) {
      this.toggleCloseWithoutSaving();
    } else {
      this.resetComponent();
      this.props.closeDrawer();
    }
  };

  resetComponent = () => this.setState(cloneDeep(initialState));

  handlePageChange = nextPage => {
    this.props.closeDrawer();
    this.props.setPrescreenIndex(nextPage);
  };

  toggleEditMade = question => {
    if (isEqual(question, this.props.question)) {
      this.setState({ editMade: false });
    } else {
      this.setState({ editMade: true });
    }
  };

  handleQuestionChange = e => {
    const question = e.target.value;
    this.setState({ question }, this.toggleEditMade(true));
    this.validateQuestion(question);
  };

  handleAnswerValueChange = (answer, index) => {
    const { answers } = this.state;
    if (answers.length === 0) {
      answers.push(answer);
    } else {
      answers[index] = answer;
      this.setState({ answers });
    }
  };

  handleCreateAnswer = answer => {
    const { answers } = this.state;
    answers.push(answer);
    this.setState({ answers });
  };

  handleAnswerLimitChange = answerLimit => this.setState({ answerLimit });

  validateQuestion = question => {
    if (question.length > 0) {
      this.setState({ questionError: false });
    } else {
      this.setState({ questionError: true });
    }
  };

  handleDismissRemoveQuestion = () => this.setState({ removeQuestion: false });
  toggleCloseWithoutSaving = () =>
    this.setState({ closeWithoutSaving: !this.state.closeWithoutSaving });

  handleCreateQuestion = () => {
    const { question, answerLimit, answers } = this.state;
    createPrescreenQuestion({ question, answerLimit, answers })
      .then(res => {
        AppToaster.show({
          message: res.data.message,
          intent: Intent.SUCCESS,
        });
        this.props.fetchPrescreenQuestions();
        this.setState({ editMade: false }, this.handleCloseDrawer);
      })
      .catch(err => {
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
      });
  };

  handleArchiveAnswer = index => {
    const answers = filter(this.state.answers, (a, i) => i !== index);
    this.setState({ answers });
  };

  render() {
    const { question, answers, answerLimit } = this.state;
    const { isOpen } = this.props;

    return (
      <Drawer isOpen={isOpen} onClose={this.handleCloseDrawer}>
        <DrawerHeader>
          Add Question
          {this.state.editMade ? (
            <FlexRow fontSize="0.7rem" width="15rem">
              <BlueTextPointer onClick={this.toggleCloseWithoutSaving}>
                DISCARD
              </BlueTextPointer>
              <PlainButton
                onClick={this.handleCreateQuestion}
                disabled={
                  this.state.questionError || this.state.answers.length === 0
                }
              >
                SAVE CHANGES
              </PlainButton>
            </FlexRow>
          ) : (
            <HeaderControls>
              <Button
                icon={IconNames.CROSS}
                onClick={this.handleCloseDrawer}
                minimal
              />
            </HeaderControls>
          )}
        </DrawerHeader>
        <ScrollWrapper>
          {this.state.questionError && (
            <ErrorWrapper>The question field cannot be blank.</ErrorWrapper>
          )}
          <FormTextAreaGroup
            label="Text"
            requiredLabel={false}
            name="question"
            fill={true}
            value={question}
            handleChange={this.handleQuestionChange}
            style={{ background: colors.formBackground }}
          />
          <BorderWrapper>
            <PrescreenAnswers
              answers={answers}
              openParent={this.props.openDrawer}
              isParentOpen={this.props.isOpen}
              question={question}
              newQuestion={true}
              fetchPrescreenQuestions={this.props.fetchPrescreenQuestions}
              handleAnswerValueChange={this.handleAnswerValueChange}
              handleCreateAnswer={this.handleCreateAnswer}
              categories={this.props.categories}
              archiveLocalAnswer={this.handleArchiveAnswer}
            />
          </BorderWrapper>
          <CategoryLabel>Answer Limit</CategoryLabel>
          <Select
            onChange={this.handleAnswerLimitChange}
            value={mapAnswerLimit(answerLimit)}
            options={map(new Array(answers && answers.length), (a, i) => {
              if (i === 0) {
                return { label: 'No Limit', value: i };
              } else {
                return {
                  label: i,
                  value: i,
                };
              }
            })}
          />

          <DialogWrapper
            isOpen={this.state.closeWithoutSaving}
            onClose={this.toggleCloseWithoutSaving}
            title="You have unsaved changes on this page"
            body="If you leave this page, all unsaved changes will be lost. Are you sure you want to leave this page?"
            confirm="LEAVE PAGE"
            action={() => {
              this.setState(
                { editMade: false, closeWithoutSaving: false },
                this.handleCloseDrawer
              );
            }}
          />
        </ScrollWrapper>
      </Drawer>
    );
  }
}

export default PrescreenAddQuestionDrawer;
